import { useState, useEffect } from 'react';

const LS_KEY = 'diavice_hide_financials';
const EVENT = 'financials-toggle';

export function useHideFinancials() {
  const [hidden, setHidden] = useState(() => localStorage.getItem(LS_KEY) === 'true');

  useEffect(() => {
    const handler = () => setHidden(localStorage.getItem(LS_KEY) === 'true');
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);

  const toggle = () => {
    const next = !hidden;
    localStorage.setItem(LS_KEY, String(next));
    window.dispatchEvent(new Event(EVENT));
  };

  return [hidden, toggle];
}
